export const TableHelpers = {
    data() {
        return {
            tableColumns: [
                {
                    title: this.$t('Usuario'),
                    type: 'custom-html',
                    key: 'user',
                    modifier: (value) => {

                        return value.full_name;
                    }
                },
                {
                    title: this.$t('Inicio de sesión'),
                    type: 'text',
                    key: 'session_start',
                },
                // {
                //     title: this.$t('email'),
                //     type: 'text',
                //     key: 'email',

                // },
                {
                    title: this.$t('Cierre de sesión'),
                    type: 'custom-html',
                    key: 'session_end',
                    isVisible: true,
                    modifier: (value) => {
                        if (!value) {
                            return "-";
                        }
                        else {
                            return value;
                        }
                    }
                },
                {
                    title: this.$t('Estado de sesión'),
                    type: 'custom-html',
                    key: 'session_end',
                    isVisible: true,
                    modifier: (value) => {
                        let tmp = "";
                        let ClassName = 'danger';
                        if (!value) {
                            ClassName = `danger`;
                            tmp = 'Sesión sin cerrar'
                        }
                        else if (value) {
                            ClassName = `success`;
                            tmp = 'Sesiós cerrada'
                        }

                        return `<span class="badge badge-sm badge-pill badge-${ClassName}">${tmp}</span>`;
                    }
                },
                // {
                //     title: this.$t('phone'),
                //     type: 'text',
                //     key: 'phone',
                // },
                // {
                //     title: this.$t('age'),
                //     type: 'text',
                //     key: 'age',
                // },
                // {
                //     title: this.$t('gender'),
                //     type: 'custom-html',
                //     key: 'gender',
                //     modifier: (value) => {
                //         return `<span>${this.$t(value)}</span>`

                //     }
                // },
            ],
            actionObj: {
                title: this.$t('action'),
                type: 'action',
            }
        }
    },
}